import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import { usePathContext } from '../context/PathContext.js';
import { useSubmitPathNodeFlowMutation } from '../mutations/SubmitPathNodeFlow.generated.js';
import { PathGraphFlowRunMode } from '../generated/types.js';
import useHandleNextNode from '../hooks/useHandleNextNode.js';

function useSubmitInterstitialCommand(_ref) {
  var pathNodeId = _ref.pathNodeId;
  var pathContext = usePathContext();
  var handleNextNode = useHandleNextNode();

  var _useSubmitPathNodeFlo = useSubmitPathNodeFlowMutation({
    onCompleted: function onCompleted(_ref2) {
      var submitPathNodeFlowInputCommands = _ref2.submitPathNodeFlowInputCommands;

      var _a, _b, _c;

      if (submitPathNodeFlowInputCommands.error) {
        pathContext.onSetPathGraphFlowErrors(submitPathNodeFlowInputCommands.error);
        return;
      }
      /**
       * Track the node submission before the node advances in the `handleNextNode` call.
       * We use a pathContext reference here instead of the mutation response.
       */


      if (pathContext.runMode !== PathGraphFlowRunMode.DRY_RUN) {
        (_a = window.tracking) === null || _a === void 0 ? void 0 : _a.events.trackPathClientFlowNodeSubmitted({
          path_graph_flow_id: (_b = pathContext.pathGraphFlow) === null || _b === void 0 ? void 0 : _b.id,
          nodes: ((_c = pathContext.activeNode) === null || _c === void 0 ? void 0 : _c.references) || []
        });
      }

      if (submitPathNodeFlowInputCommands.pathGraphFlow) {
        handleNextNode({
          pathGraphFlow: submitPathNodeFlowInputCommands.pathGraphFlow
        });
      }
    }
  }),
      _useSubmitPathNodeFlo2 = _slicedToArray(_useSubmitPathNodeFlo, 2),
      submitPathNodeFlow = _useSubmitPathNodeFlo2[0],
      loading = _useSubmitPathNodeFlo2[1].loading;

  return [function () {
    submitPathNodeFlow({
      variables: {
        input: {
          id: pathContext.pathGraphFlowId,
          commands: [{
            id: pathNodeId,
            submitInterstitial: {}
          }]
        }
      }
    });
  }, {
    loading: loading
  }];
}

export default useSubmitInterstitialCommand;
//# sourceMappingURL=useSubmitInterstitialCommand.js.map
